import { useMutation } from "@tanstack/react-query";
import { lodListApi } from "components/api/comm";
import { ILod } from "interface";
import { useEffect, useState } from "react";
import { successControl } from "util/commAction";
import LodList from "components/view/lod";

export default function LodListPage() {
  const [lodList, setLodList] = useState<ILod[]>([]);

  const lodMutation = useMutation({
    mutationFn: lodListApi,
    onSuccess: (res) => {
      const { code } = res.status;
      if (code === 0) {
        setLodList(res.data.lodList);
      }
      successControl({
        status: res.status,
        success: () => {},
      });
    },
  });

  useEffect(() => {
    lodMutation.mutate();
  }, []);

  return <LodList lodList={lodList} />;
}
